<div
  class="notification-banner"
  [ngClass]="type"
  *ngIf="visible && feature?.showNotification == true"
  [@animate]="{ value: '*', params: { delay: '300ms' } }">
  <div class="icon-wrapper">
    <span class="material-icons shake-animation">notifications</span>
  </div>

  <div class="notification-content">
    <h4 class="notification-title">{{ feature?.title }}</h4>
    <p class="notification-description">{{ feature?.description }}</p>

    <redirect-to-button
      *ngIf="feature?.buttonLabel && feature?.redirectTo"
      [label]="feature.buttonLabel"
      [redirectTo]="feature.redirectTo">
    </redirect-to-button>
  </div>

  <button class="close-btn" (click)="onClose()">×</button>
</div>
